exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-form-label{align-items:baseline;color:var(--ds-color-london-5);display:inline-flex;font-family:var(--ds-type-system-sans-lining);font-size:var(--ds-type-scale-0);font-weight:500;line-height:var(--ds-type-leading-lower);max-width:33rem}.ds-form-label--inverse{color:var(--ds-color-london-100);-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.ds-form-tag{color:var(--ds-color-london-35);font-family:var(--ds-type-system-sans);font-size:var(--ds-type-scale--2);font-variant:small-caps no-common-ligatures no-discretionary-ligatures no-historical-ligatures no-contextual;font-weight:500;line-height:var(--ds-type-leading-lower);padding:0 0 0 .5rem;text-transform:lowercase}.ds-form-label--inverse .ds-form-tag{color:var(--ds-color-london-95)}", ""]);

// exports
exports.locals = {
	"ds-form-label": "ds-form-label",
	"ds-form-label--inverse": "ds-form-label--inverse",
	"ds-form-tag": "ds-form-tag"
};